import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

type ApiKeysReducerType = {
  search: string;
  customerId: Nullable<string>;
  userId: Nullable<string>;
  revoked: Nullable<boolean>;
};

const initialState: ApiKeysReducerType = {
  search: "",
  customerId: null,
  userId: null,
  revoked: null,
};

const apiKeysSlice = createSlice({
  name: "admin/api-keys",
  initialState,
  reducers: {
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    setCustomerId(state, action: PayloadAction<Nullable<string>>) {
      state.customerId = action.payload;
      state.userId = null;
    },
    setUserId(state, action: PayloadAction<Nullable<string>>) {
      state.userId = action.payload;
    },
    setRevoked(state, action: PayloadAction<Nullable<boolean>>) {
      state.revoked = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setSearch, setCustomerId, setUserId, setRevoked, resetFilters } = apiKeysSlice.actions;
export const adminApiKeysSelector = (state: RootState) => state.admin.apiKeys;
export default apiKeysSlice.reducer;
